export * from './post-zeit-art.component';
export * from './post-zeit-art.component.module';